module.exports = "<component-handler loaded=\"bundleCtrl.loaded\" error=\"bundleCtrl.error\"></component-handler>\n<div class=\"row m-b-xl\" ng-show=\"bundleCtrl.loaded && !bundleCtrl.error.status\">\n\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t\t<uib-tabset active=\"active\">\n\t\t\t<uib-tab index=\"0\" class=\"no-borders text-success\">\n\t\t\t\t<uib-tab-heading>\n\t\t\t\t\t<i class=\"fa fa-book\"></i> Bundle\n\t\t\t\t</uib-tab-heading>\n\t\t\t\t<bundle-info ng-model=\"bundleCtrl.bundle\"></bundle-info>\n\t\t\t</uib-tab>\n\t\t</uib-tabset>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bundle/template.html
// module id = 1281
// module chunks = 0